import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * InfoTip — a small hover-triggered tooltip that reliably opens.
 *
 * Wraps the Shadcn/Radix Tooltip with sensible defaults so callers
 * can drop a "ⓘ" icon or wrap any content and get a real popover.
 *
 * A global <TooltipProvider> is mounted once at the App root, so
 * these will work anywhere in the tree.
 */
export default function InfoTip({
  content,
  children,
  side = "top",
  align = "center",
  maxWidth = 320,
  className = "",
  testid,
}) {
  if (!content) return children || null;
  return (
    <Tooltip delayDuration={120}>
      <TooltipTrigger asChild>
        {children ? (
          children
        ) : (
          <button
            type="button"
            aria-label="More info"
            data-testid={testid}
            className={
              "inline-flex items-center justify-center text-zinc-500 hover:text-zinc-200 " +
              "cursor-help focus:outline-none focus-visible:ring-1 focus-visible:ring-zinc-500 " +
              "rounded-full leading-none " + className
            }
            onClick={(e) => e.preventDefault()}
          >
            <span className="text-[10px] select-none">ⓘ</span>
          </button>
        )}
      </TooltipTrigger>
      <TooltipContent
        side={side}
        align={align}
        style={{ maxWidth }}
        className="bg-zinc-900 text-zinc-100 border border-zinc-700 shadow-lg text-[11px] leading-snug px-3 py-2 whitespace-normal"
      >
        {content}
      </TooltipContent>
    </Tooltip>
  );
}
